import { Component, inject, model, computed } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LucideIconComponent } from '../../lucide-icon/lucide-icon.component';
import { NavigationService } from '../../../../core/services/navigation.service';
import { ButtonComponent } from '../../button/button.component';
import { FleetService } from '../../../../core/services/fleet.service';

import { TextComponent } from '../../typography/text/text.component';
import { ToggleComponent } from '../../forms/toggle/toggle.component';
import { FormsModule } from '@angular/forms';
import { ThemeService } from '../../../../core/theme/theme.service';
import { NotificationBellComponent } from '../../notifications/notification-bell/notification-bell.component';

@Component({
  selector: 'app-desktop-sidebar',
  standalone: true,
  imports: [
    NgClass,
    RouterLink,
    RouterLinkActive,
    LucideIconComponent,
    ButtonComponent,
    TextComponent,
    ToggleComponent,
    FormsModule,
    NotificationBellComponent,
  ],
  templateUrl: './desktop-sidebar.component.html',
  styleUrl: './desktop-sidebar.component.css',
})
export class DesktopSidebarComponent {
  navService = inject(NavigationService);
  private fleetService = inject(FleetService);
  themeService = inject(ThemeService);

  /**
   * The collapsed state can be controlled from the outside by the parent layout.
   * We use a model() signal so the parent can have two-way binding if needed.
   */
  collapsed = model(false);
  
  protected readonly currentYear = new Date().getFullYear();

  protected fleetName = computed(() => {
    return this.fleetService.currentCompanySignal()?.legalName || 'My Fleet';
  });

  protected fleetNameInitials = computed(() => {
    const fleetName = this.fleetService.currentCompanySignal()?.legalName || '';
    return fleetName
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase())
      .join('')
      .slice(0, 2); // Limit to 2 initials
  });

  protected isDarkMode = computed(() => {
    return this.themeService.theme() === 'dark';
  });

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  toggleCollapse(): void {
    this.collapsed.update((value) => !value);
  }
}
